const SHOW_MESSAGE: string = 'SHOW_MESSAGE'
const CLOSE_MESSAGE: string = 'CLOSE_MESSAGE'

export { SHOW_MESSAGE, CLOSE_MESSAGE }
